import { Node } from "@contentful/rich-text-types";

export const renderBlockEmbeddedAsset = (node: Node): string => {
    return `<img alt="" src="${node.data.target.sys.id}"/>`;
};
